import { defineComponent as _defineComponent } from 'vue'
import { computed, watch, ref, unref, onMounted } from 'vue';
    import InputCommon from '@ve/components/inputs/InputCommon.vue';
    import { onClickOutside } from '@vueuse/core';
    import Loader from '@ve/components/loader/common/Loader.vue';
    import ButtonCommon from '@fr/vue/components/button/desktop/Button.vue';
    import gaAsync from '@/js/common/Domain/Service/gaAsync';
    import { pluralize } from '@travelata-libs/utils';
    import DropDownList from './components/DropDownList.vue';
    import HotelItemFilter from './components/HotelItem.vue';


    type HotelType = { id: number, name: string };

    interface HotelsSearchInputProps {
        selectedHotels: HotelType[],
        foundedHotels: HotelType[],
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HotelsSearchInput',
  props: {
    selectedHotels: null,
    foundedHotels: null
  },
  emits: ["input-hotels", "select-hotel", "delete-hotel", "clear-hotels", "start-search"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'input-hotels', value: string): void;
        (e: 'select-hotel', value: HotelType): void;
        (e: 'delete-hotel', value: HotelType): void;
        (e: 'clear-hotels'): void;
        (e: 'start-search'): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        selectedHotels: HotelType[],
        foundedHotels: HotelType[],
    }

    

    

    const isDropDownVisible = ref<boolean>(false);
    const inputModel = ref<string>('');
    const isLoading = ref<boolean>(false);
    const element = ref(null);
    const isInputFocus = ref(false);
    const selectedHotelsIds = computed(() => props.selectedHotels.map((hotel) => hotel.id));
    const selectedHotelsText = computed(() => {
        const hotelLength = props.selectedHotels.length;
        if (!hotelLength) return '';
        return `${pluralize(['Выбран', 'Выбрано', 'Выбраны'], hotelLength, false)} ${pluralize(['отель', 'отеля', 'отелей'], hotelLength)}`
    });

    const foundedHotelsList = computed(() => props.foundedHotels.filter((hotel) => unref(selectedHotelsIds).indexOf(hotel.id) === -1));

    const placeholderText = computed(() => (unref(isDropDownVisible) ? '' : 'Поиск по названию отеля'));

    const dropDownLabel = computed(() => ((!props.foundedHotels.length && unref(inputModel).length >= 3) ? 'Ничего не найдено' : 'Введите минимум 3 символа'));

    const onInput = () => {
        if (unref(inputModel).length >= 3) {
            emit('input-hotels', unref(inputModel));
            isLoading.value = true;
        }
    };
    const selectHotel = (hotel: HotelType): void => {
        emit('select-hotel', hotel);
    };
    const deleteHotel = (hotel: HotelType): void => {
        emit('delete-hotel', hotel);
    };
    const close = (): void => {
        inputModel.value = unref(selectedHotelsText);
        isInputFocus.value = false;
        isDropDownVisible.value = false;
    };
    const open = (): void => {
        inputModel.value = '';
        isDropDownVisible.value = true;
    };

    const startSearch = (): void => {
        close();
        emit('start-search');
    };

    const clearHotels = (): void => {
        inputModel.value = '';
        emit('clear-hotels');
        startSearch();
    };

    watch(() => props.selectedHotels, () => {
        inputModel.value = unref(selectedHotelsText);
    }, { immediate: true });

    watch(() => props.foundedHotels, () => {
        isLoading.value = false;
    });


    onMounted(() => {
        onClickOutside(element, () => {
            close();
        });
    });

    const sendAnalitics = () => {
        gaAsync(() => {
            ga('set', 'dimension10', 'Hotel');
        });
    };

return { __sfc: true,props, emit, isDropDownVisible, inputModel, isLoading, element, isInputFocus, selectedHotelsIds, selectedHotelsText, foundedHotelsList, placeholderText, dropDownLabel, onInput, selectHotel, deleteHotel, close, open, startSearch, clearHotels, sendAnalitics, InputCommon, Loader, ButtonCommon, DropDownList, HotelItemFilter }
}

})